import { Address, EMPTY_ADDRESS } from '@dadohr/shared/domainTypes/address';

export const maskString = (t: string, length = 20) => {
  if (!t) {
    return '';
  }
  let x = '';
  for (let i = 0; i < length; i++) {
    x += '●';
  }
  return x;
};

export const maskAddress = (t: Address | null): Address => {
  const x = t || EMPTY_ADDRESS();
  return {
    name: maskString(x.name, 15),
    addressLine1: maskString(x.addressLine1, 12),
    addressLine2: maskString(x.addressLine2, 5),
    city: maskString(x.city, 8),
    region: maskString(x.region, 8),
    postalCode: maskString(x.postalCode, 5),
    country: maskString(x.country, 2)
  };
};

export const isMaskedString = (t: string) => {
  return /^●+$/.test(t.trim());
};
